import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import dummyData from '../../../database/events.json'
import adapter from '../../events/adapter';
import apiService from '../../api/service';
import * as config from "./config";
import { generateCoreExtraReducers, generateSliceCore } from '../../core/tools';
const { NAME } = config;

const core = generateSliceCore(config);
const app = {
  initialState: {
    _payload: null,
    status: "idle",
    error: "",
    data: dummyData,
    data_options: [],
    data_featured: dummyData
  },
  action: {
    fetchEvents: createAsyncThunk(
      `${NAME}/fetchEvents`,
      async (options) => {
        const data = await apiService.get(NAME, options);
        return data;
      }
    ),
    fetchFeaturedEvents: createAsyncThunk(`${NAME}/fetchFeaturedEvents`, async (options) => {
      const data = await apiService.get('events_featured', options);
      return data;
    }),
  }
}

/** Actions/thunks */
export const { setQuery, setCurrentPage, setSorter } = core.action
export const { fetchEvents, fetchFeaturedEvents } = app.action

/** Reducer - Extra Reducers */
const coreExtraReducers = generateCoreExtraReducers(core.action);

/** Slice */
export const organizationEventsSlice = createSlice({
  name: NAME,
  initialState: {
    ...core.initialState,
    ...app.initialState
  },
  reducers: {
    setStatus(state, action){
      state.status = action.payload
    },
    setPageItems(state, action){
      state.pageItems = action.payload
    }
  },
  extraReducers: {
    ...coreExtraReducers,

    [fetchEvents.pending]: (state) => {
      state.status = "loading";
    },
    [fetchEvents.fulfilled]: (state, action) => {
      state.status = "succeeded";
      state._payload = action.payload;
      const payload = adapter.responseBodyToRender(action.payload.results);
      state.data = payload;
      state.data_options = adapter.responseBodyToOptions(
        action.payload.results
      );
      state.totalItems = action.payload.count
    },
    [fetchEvents.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error.message;
    },

    [fetchFeaturedEvents.fulfilled]: (state, action) => {
      state.data_featured_payload = action.payload;
      state.data_featured = adapter.responseBodyToRender(action.payload);
    }
  }
})

export const { setStatus, setPageItems } = organizationEventsSlice.actions
export const eventsActions = {
  ...organizationEventsSlice.actions,
  ...core.action,
  ...app.action,
};
export default organizationEventsSlice.reducer
